import { FormattedDate} from "react-intl"
import React from "react"

type OwnProps = {
    date: string
}
const DateDisplayComponent = (props: OwnProps) => { 
    if (!props.date) { return <> - </> } 

    return ( 
        <FormattedDate 
            year='numeric' 
            month='long' 
            day='numeric' 
            value={new Date(props.date)} 
        />
    ) 
}
export default DateDisplayComponent


// WEBPACK FOOTER //
// ./src/common/inline-edit/component/DateDisplayComponent.tsx